import IMCategoriesPromotion from './IMCategoriesPromotion';

export default IMCategoriesPromotion;
